module.exports = __webpack_public_path__ + "img/home.aa6bc9fc.png";